<template>
  <el-dialog
    :visible="visible"
    title="退款信息"
    @close="$emit('update:visible', false)"
    @closed="handleClose"
    @open="handleOpen"
  >
    <el-form label-width="120px">
      <el-form-item label="买家信息：">
        <el-input disabled :value="data.buyerOrgName"></el-input>
      </el-form-item>
      <el-form-item label="退款金额：">
        <el-input disabled :value="amount | currencyFormat">
          <template v-slot:append>元</template>
        </el-input>
      </el-form-item>
      <el-form-item label="退款凭据：" required>
        <upload-list
          ref="uploadList"
          :limit="3"
          :extraParams="extraParams"
          :preview="data.isPreview"
        ></upload-list>
      </el-form-item>
      <el-form-item label="备注信息：">
        <el-input
          v-model.trim="remark"
          type="textarea"
          show-word-limit
          placeholder="请输入备注信息"
          maxlength="200"
          :disabled="data.isPreview"
        ></el-input>
      </el-form-item>
    </el-form>
    <template v-slot:footer>
      <div style="text-align:center;">
        <el-button @click="$emit('update:visible', false)">关 闭</el-button>
        <el-button type="primary" @click="commit" v-if="!data.isPreview">确认上传</el-button>
      </div>
    </template>
  </el-dialog>
</template>

<script>
import UploadList from './upload-list'
import { fileUrlAdapter } from '@/common/filters'
import { isImage } from '@/common/utils/validate'

export default {
  components: { UploadList },
  props: {
    visible: Boolean,
    data: Object
  },
  data() {
    return {
      remark: '',
      amount: ''
    }
  },
  computed: {
    extraParams() {
      return { orgIds: this.data.buyerOrgId }
    }
  },
  methods: {
    async handleOpen() {
      if (this.data.isPreview) {
        const request = {
          bizOrderId: this.data.bizOrderId,
          accountPayId: this.data.accountPayId
        }
        const { success, data } = await this.$post('accountPay.seller.queryCert', { request })
        if (success && data) {
          const { certAmount, certUrls, remark } = data[0].accountPayCertVO
          this.amount = certAmount
          this.remark = remark
          if (certUrls) {
            const file = []
            certUrls.forEach(fk => {
              const obj = {}
              obj.url = fileUrlAdapter(fk)
              if (!isImage(fk)) {
                obj.type = fk.split('.')[1].toUpperCase()
              }
              file.push(obj)
            })
            this.$refs.uploadList.setFileList(file)
          }
        }
      } else {
        this.amount = this.data.amount
      }
    },
    handleClose() {
      this.$refs.uploadList.reset()
      this.remark = ''
    },
    async commit() {
      const filtList = this.$refs.uploadList.getFileList()
      if (filtList.length === 0) {
        this.$message.error('请上传退款凭证')
        return
      }
      //校验是否上传完成
      const ready = filtList.find(ele => ele.status === 'ready')
      if (ready) {
        this.$message.error('请等待图片上传完成')
        return
      }
      const request = {
        bizOrderId: this.data.bizOrderId,
        accountPayId: this.data.accountPayId
      }
      if (this.remark) {
        request.remark = this.remark
      }
      const certUrls = []
      filtList.forEach(ele => {
        certUrls.push(ele.fk)
      })
      request.certUrls = certUrls
      const { success, data } = await this.$post('accountPay.seller.saveCert', { request })
      if (success && data) {
        const { value } = data[0]
        if (value) {
          this.$message.success('提交成功')
          setTimeout(() => {
            this.$emit('refresh')
            this.$emit('update:visible', false)
          }, 300)
        } else {
          this.$message.error('提交失败')
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>
